// extracted by mini-css-extract-plugin
export default {"rating":"yM-z","numberOfStars":"zM-z","count":"AM-z","barGraphSpacing":"BM-z","barGraph":"CM-z"};